import { CampaignDefaultThreadStarterContentType } from '@ms/yammer-graphql';

import { Campaign, EntityStatus, YammerState, getStatusForId } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

type GetStatusForCampaignId = (state: YammerState, campaignId: Campaign['id']) => EntityStatus;
export const getStatusForCampaignId: GetStatusForCampaignId = (state, campaignId) =>
  getStatusForId(state.campaigns, campaignId);

export const findCampaignById = createFindById<Campaign>('campaigns');
export const findCampaignByIdThrows = createFindByIdThrows<Campaign>('campaigns');

type GetCampaignDatabaseId = (state: YammerState, campaignId: Campaign['id']) => Campaign['databaseId'];
export const getCampaignDatabaseId: GetCampaignDatabaseId = (state, campaignId) =>
  findCampaignByIdThrows(state, campaignId).databaseId;

type GetThreadStarterDefaultContentType = (
  state: YammerState,
  campaignId: Campaign['id']
) => CampaignDefaultThreadStarterContentType;
export const getThreadStarterDefaultContentType: GetThreadStarterDefaultContentType = (state, campaignId) => {
  const campaign = findCampaignById(state, campaignId);

  if (!campaign) {
    return CampaignDefaultThreadStarterContentType.NORMAL;
  }

  return campaign.threadStarterDefaultContentType;
};

type IsDefaultPostTypeQuestion = (state: YammerState, campaignId: Campaign['id']) => boolean;
export const isDefaultPostTypeQuestion: IsDefaultPostTypeQuestion = (state, campaignId) => {
  const defaultPostType = getThreadStarterDefaultContentType(state, campaignId);

  return defaultPostType === CampaignDefaultThreadStarterContentType.QUESTION;
};

type IsDefaultPostTypePraise = (state: YammerState, campaignId: Campaign['id']) => boolean;
export const isDefaultPostTypePraise: IsDefaultPostTypePraise = (state, campaignId) => {
  const defaultPostType = getThreadStarterDefaultContentType(state, campaignId);

  return defaultPostType === CampaignDefaultThreadStarterContentType.PRAISE;
};

type IsDefaultPostTypePoll = (state: YammerState, campaignId: Campaign['id']) => boolean;
export const isDefaultPostTypePoll: IsDefaultPostTypePoll = (state, campaignId) => {
  const defaultPostType = getThreadStarterDefaultContentType(state, campaignId);

  return defaultPostType === CampaignDefaultThreadStarterContentType.POLL;
};

interface GetDefaultPostTypeReturnTypeValue {
  readonly isDefaultPostTypeQuestion: boolean;
  readonly isDefaultPostTypePraise: boolean;
  readonly isDefaultPostTypePoll: boolean;
}
type GetDefaultPostType = (state: YammerState, campaignId?: Campaign['id']) => GetDefaultPostTypeReturnTypeValue;
export const getDefaultPostType: GetDefaultPostType = (state, campaignId) => {
  if (!campaignId) {
    return {
      isDefaultPostTypeQuestion: false,
      isDefaultPostTypePraise: false,
      isDefaultPostTypePoll: false,
    };
  }

  return {
    isDefaultPostTypeQuestion: isDefaultPostTypeQuestion(state, campaignId),
    isDefaultPostTypePraise: isDefaultPostTypePraise(state, campaignId),
    isDefaultPostTypePoll: isDefaultPostTypePoll(state, campaignId),
  };
};

type CanStartThread = (state: YammerState, campaignId: Campaign['id']) => boolean;
export const canStartThread: CanStartThread = (state, campaignId) => {
  const campaign = findCampaignById(state, campaignId);

  if (!campaign) {
    return false;
  }

  return campaign.viewerCanStartThread;
};
